import { render, staticRenderFns } from "./PaymentMethodCard.vue?vue&type=template&id=5ccedeee&scoped=true"
import script from "./PaymentMethodCard.vue?vue&type=script&lang=js"
export * from "./PaymentMethodCard.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethodCard.vue?vue&type=style&index=0&id=5ccedeee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccedeee",
  null
  
)

export default component.exports